document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.tgl-header');
  const slideMenu = document.getElementById('slideMenu');
  const hamburger = document.querySelector('[data-toggle-menu]');
  const closeButtons = document.querySelectorAll('[data-close-menu]');
  const scrollLinks = document.querySelectorAll('[data-scroll-target]');
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const isProductTemplate = document.body.classList.contains('template-product');

  const updateThemeColor = () => {
    if (!themeColorMeta || !isProductTemplate) return;
    const shouldBeWhite = header && (header.classList.contains('scrolled') || header.classList.contains('menu-open'));
    themeColorMeta.setAttribute('content', shouldBeWhite ? '#ffffff' : '#f9f2d7');
  };

  const setHeaderHeightVar = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--tgl-header-height', `${header.offsetHeight}px`);
  };

  const toggleMenu = (forceState) => {
    if (!slideMenu) return;
    const shouldOpen = typeof forceState === 'boolean' ? forceState : !slideMenu.classList.contains('active');

    if (shouldOpen && window.TGLCartDrawer && typeof window.TGLCartDrawer.close === 'function') {
      window.TGLCartDrawer.close();
    }

    slideMenu.classList.toggle('active', shouldOpen);
    if (header) {
      header.classList.toggle('menu-open', shouldOpen);
    }
    document.documentElement.classList.toggle('tgl-menu-open', shouldOpen);
    document.body.classList.toggle('tgl-menu-open', shouldOpen);
    updateThemeColor();
  };

  const closeMenu = () => toggleMenu(false);

  const updateHeaderState = () => {
    if (!header) return;
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    updateThemeColor();
  };

  const scrollToTarget = (targetSelector) => {
    if (!targetSelector) return false;
    const target = document.querySelector(targetSelector);
    if (!target) return false;

    const headerHeight = header ? header.offsetHeight : 0;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
    return true;
  };

  if (hamburger) {
    hamburger.addEventListener('click', () => toggleMenu());
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closeMenu());
  });

  document.addEventListener('click', (event) => {
    if (!slideMenu || !slideMenu.classList.contains('active')) return;
    const isInsideMenu = slideMenu.contains(event.target);
    const isHamburger = hamburger && hamburger.contains(event.target);
    if (!isInsideMenu && !isHamburger) {
      closeMenu();
    }
  });

  scrollLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetSelector = link.dataset.scrollTarget;
      if (!targetSelector) return;

      event.preventDefault();
      const scrolled = scrollToTarget(targetSelector);

      if (!scrolled) {
        const hash = targetSelector.startsWith('#') ? targetSelector : `#${targetSelector}`;
        window.location.href = `/${hash.replace(/^#/, '#')}`;
      }

      closeMenu();
    });
  });

  if (header) {
    setHeaderHeightVar();
    window.addEventListener('scroll', updateHeaderState);
    updateHeaderState();
  }

  window.addEventListener('resize', setHeaderHeightVar);
  window.addEventListener('load', setHeaderHeightVar);

  const hash = window.location.hash;
  if (hash === '#our-story' || hash === '#featured-products') {
    setTimeout(() => {
      scrollToTarget(hash);
    }, 100);
  }
});
